import githubSearch from './githubSearch/reducers';
import questionnairesReducer from './questionnaire/reducers';
import KarieUsers from './karieUsers/reducer';
import Clients from './clients/reducers';
import Users from './users/reducers';
import Accounts from './accounts/reducers';
import Devices from './devices/reducers';
import EventTypes from './events/reducers';
import DeviceEvents from './deviceEvents/reducers';
import Auth from './auth/reducer';
import SupportDevices from './support/devices/reducers';
import Schedules from './schedules/reducers';
import SupportDocuments from './support/documents/reducers';
import GlobalNotificationHandler from './notification/reducers';
import LocalServices from './support/monitoring/reducers';
import UpdatePackages from './updatePackages/reducers';
import DeviceVersion from "./deviceVersion/reducers";
import Manufacturing from './manufacturing/reducer'

export default {
  Auth,
  githubSearch,
  Users,
  Accounts,
  Clients,
  Devices,
  DeviceEvents,
  EventTypes,
  questionnairesReducer,
  KarieUsers,
  SupportDevices,
  Schedules,
  SupportDocuments,
  GlobalNotificationHandler,
  LocalServices,
  UpdatePackages,
  DeviceVersion,
  Manufacturing,
};
